module.exports = __webpack_public_path__ + "img/carousel2.4003142a.jpg";